<template>
  <div class="main-container">
    <!-- SECCIÓN ITINERARIO Y MESA DE REGALOS -->
    <section ref="itineraryRef" class="itinerary-section">
      <!-- CONTENEDOR 100% ANCHO CON FONDO CAFÉ-DORADO -->
      <div class="itinerary-full-width" ref="itineraryCardRef">
        <h2 class="itinerary-title" ref="itineraryTitle">ITINERARIO</h2>

        <div class="horizontal-container">
        
          <!-- Evento 2 -->
          <div class="itinerary-col" ref="item1">
            <div class="icon-wrapper">
              <img src="@/assets/8.png" alt="Recepción" @load="onImageLoad" />
            </div>
            <h3 class="event-title">Recepción<br></h3>
            <span class="time">4:30 PM</span>
          </div>
 
           <div class="itinerary-col" ref="item2">
            <div class="icon-wrapper">
              <img src="@/assets/c.png" alt="Fiesta" @load="onImageLoad" />
            </div>
            <h3 class="event-title">Cena<br></h3>
            <span class="time">6:00 - 7:00 PM </span>
        </div>
          <!-- Evento 3 -->
          <div class="itinerary-col" ref="item3">
            <div class="icon-wrapper">
              <img src="@/assets/fi.png" alt="Fiesta" @load="onImageLoad" />
            </div>
            <h3 class="event-title">Fiesta<br></h3>
            <span class="time">7:00 PM – en adelante</span>
          </div>
        </div>

        <!-- DIVISOR ELEGANTE 1 -->
        <div class="gold-divider" ref="dividerRef"></div>

        <!-- SECCIÓN MESA DE REGALOS -->
        <div class="gifts-section" ref="giftsSectionRef">
          <h2 class="gifts-title">MESA DE REGALOS</h2>
          <button class="btn-fine-gold" @click="isModalOpen = true">
            Ver opciones
          </button>
        </div>

        <!-- DIVISOR ELEGANTE 2 -->
        <div class="gold-divider" ref="dividerDressCodeRef"></div>

        <!-- SECCIÓN DRESS CODE -->
        <div class="dresscode-section" ref="dressCodeSectionRef">
          <h2 class="dresscode-title">DRESS CODE</h2>
          <p class="dresscode-text">
            Reservamos los colores azules exclusivamente para el quinceañero.
          </p>
          <div class="palette-wrapper">
            <img 
              src="@/assets/paleta.png" 
              alt="Paleta de Colores" 
              class="palette-img" 
              @load="onImageLoad" 
            />
          </div>
        </div>
      </div>
    </section>

    <!-- MODAL FINO DE MESA DE REGALOS -->
    <Transition name="fade-modal">
      <div v-if="isModalOpen" class="modal-backdrop" @click="isModalOpen = false">
        <div class="modal-container-wrapper" @click="isModalOpen = false">
          <!-- Botón de Cierre -->
          <button class="close-btn" @click.stop="isModalOpen = false" aria-label="Cerrar modal">✕</button>

          <img src="@/assets/conte2.png" alt="Marco Modal" class="bg-contenedor-modal" />

          <div class="modal-content-overlay">
            <!-- FLOR DECORATIVA ENTRADA EDITORIAL (VOLTEADA EN EJE X) -->
            <img src="@/assets/CORON.png" alt="Flor Decorativa" class="modal-flower-icon" />

            <p class="modal-message">
              Lo más importante es tu presencia, <br> pero si deseas realizar una muestra <br> de cariño estaremos muy agradecidos.
              <br> <br>
            </p>

          

            <!-- LLUVIA DE SOBRES -->
            <div class="gift-option envelope-option">
              <img src="@/assets/sobree.png" alt="Sobre" class="envelope-icon" />
              <h4 class="option-title">Lluvia de Sobres</h4>
              <p class="envelope-desc"></p>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

ScrollTrigger.config({
  ignoreMobileResize: true
})

export default {
  name: 'ItinerarioConMesaYModal',
  setup() {
    // Estado Modal
    const isModalOpen = ref(false)

    // Refs Principales
    const itineraryRef = ref(null)
    const itineraryCardRef = ref(null)
    const itineraryTitle = ref(null)
    const item1 = ref(null)
    const item2 = ref(null)
    const item3 = ref(null)
    const dividerRef = ref(null)
    const giftsSectionRef = ref(null)

    // Refs Dress Code
    const dividerDressCodeRef = ref(null)
    const dressCodeSectionRef = ref(null)

    // Recalcular ScrollTrigger cada vez que una imagen termine de cargar su altura
    const onImageLoad = () => {
      ScrollTrigger.refresh()
    }

    onMounted(async () => {
      await nextTick()

      // 1. FILTRAR ELEMENTOS VÁLIDOS PARA EVITAR VALORES NULL
      const itineraryItems = [item1.value, item2.value, item3.value].filter(Boolean)
      const secondaryElements = [
        dividerRef.value, 
        giftsSectionRef.value, 
        dividerDressCodeRef.value, 
        dressCodeSectionRef.value
      ].filter(Boolean)

      if (itineraryCardRef.value) {
        gsap.set(itineraryCardRef.value, { opacity: 0, y: 40, force3D: true })
      }
      if (itineraryTitle.value) {
        gsap.set(itineraryTitle.value, { opacity: 0, y: 20, force3D: true })
      }
      if (itineraryItems.length) {
        gsap.set(itineraryItems, { opacity: 0, y: 25, force3D: true })
      }
      if (secondaryElements.length) {
        gsap.set(secondaryElements, { opacity: 0, y: 20, force3D: true })
      }

      // 2. TIMELINE TARJETA: ITINERARIO, MESA Y DRESS CODE
      if (itineraryCardRef.value) {
        const cardTL = gsap.timeline({
          scrollTrigger: {
            trigger: itineraryCardRef.value,
            start: 'top 85%',
            toggleActions: 'play none none none',
            once: true
          }
        })

        cardTL
          .to(itineraryCardRef.value, {
            opacity: 1,
            y: 0,
            duration: 0.5,
            ease: 'power3.out'
          })
          .to(itineraryTitle.value, {
            opacity: 1,
            y: 0,
            duration: 0.3,
            ease: 'power2.out'
          }, '-=0.3')
          .to(itineraryItems, {
            opacity: 1,
            y: 0,
            stagger: 0.1,
            duration: 0.4,
            ease: 'power2.out'
          }, '-=0.15')
          .to(secondaryElements, {
            opacity: 1,
            y: 0,
            stagger: 0.08,
            duration: 0.35,
            ease: 'power2.out'
          }, '-=0.2')
      }

      // Forzar actualización inicial
      ScrollTrigger.refresh()
      setTimeout(() => {
        ScrollTrigger.refresh()
      }, 300)
    })

    onBeforeUnmount(() => {
      ScrollTrigger.getAll().forEach(t => t.kill())
    })

    return {
      isModalOpen,
      itineraryRef,
      itineraryCardRef,
      itineraryTitle,
      item1,
      item2,
      item3,
      dividerRef,
      giftsSectionRef,
      dividerDressCodeRef,
      dressCodeSectionRef,
      onImageLoad
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,500;1,600&family=Playfair+Display:ital,wght@0,500;0,600;1,400&display=swap');

/* ===== CONTENEDOR PRINCIPAL ===== */
.main-container {
  background-color: rgba(217, 212, 209, 0.95);
  font-family: system-ui, -apple-system, sans-serif;
  color: #000;
  overflow-x: hidden;
  padding: 0px 0 0px;
  margin-top:-8px;
}

.itinerary-section {
  width: 100%;
}

/* ===== TARJETA DE ITINERARIO (100% WIDTH CAFÉ DORADO) ===== */
.itinerary-full-width {
  width: 100%;
  background-image: 
    linear-gradient(rgba(0, 0, 0, 0.733), rgba(0, 0, 0, 0.605)), 
    url('@/assets/B3D70B5E-2599-498C-923E-4B6C6082F8F9.png');  
     background-size: cover;
  background-position: center;
  background-repeat: no-repeat;  border-top: 2px solid #c5a059;
  border-bottom: 2px solid #c5a059;
  padding: 40px 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  color: #f7f3ee;
  margin-bottom: 40px;
  box-sizing: border-box;
}

.itinerary-title {
  font-family: 'Playfair Display', 'padres', serif;
  font-size: 26px;
  letter-spacing: 4px;
  text-align: center;
  margin: 0 0 35px 0;
  color: #dfb76c;
  font-weight: 500;
}

.horizontal-container {
  max-width: 650px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  gap: 15px;
  flex-wrap: wrap;
}

.itinerary-col {
  flex: 1;
  min-width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.icon-wrapper {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.icon-wrapper img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  filter: brightness(0) invert(0.85) sepia(0.5) hue-rotate(5deg);
}

.event-title {
  font-family: 'Playfair Display', 'padres', serif;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin: 0 0 6px 0;
  color: #ffffff;
  font-weight: 600;
}

.time {
  font-size: 12px;
  font-weight: 500;
  color: #dfb76c;
}

/* ===== DIVISOR ELEGANTE ===== */
.gold-divider {
  width: 120px;
  height: 1px;
  background: linear-gradient(90deg, transparent, #c5a059, transparent);
  margin: 35px auto 25px;
}

/* ===== MESA DE REGALOS (DENTRO DE FRANJA) ===== */
.gifts-section {
  text-align: center;
  max-width: 400px;
  margin: 0 auto;
}

.gifts-title {
  font-family: 'Playfair Display', 'padres', serif;
  font-size: 20px;
  letter-spacing: 3px;
  margin: 0 0 16px 0;
  color: #dfb76c;
  font-weight: 500;
}

.btn-fine-gold {
  background: transparent;
  border: 1px solid #c5a059;
  color: #f7f3ee;
  padding: 8px 24px;
  border-radius: 20px;
  font-size: 12px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Playfair Display', serif;
}

.btn-fine-gold:hover {
  background-color: #c5a059;
  color: #1a0f0d;
}

/* ===== SECCIÓN DRESS CODE ===== */
.dresscode-section {
  text-align: center;
  max-width: 450px;
  margin: 0 auto;
}

.dresscode-title {
  font-family: 'Playfair Display', 'padres', serif;
  font-size: 25px !important;
  letter-spacing: 3px;
  margin: 0 0 12px 0;
  color: #dfb76c;
  font-weight: 500;
}

.dresscode-text {
  font-family: 'Cormorant Garamond', serif;
  font-style: italic;
  font-size: 19px;
  color: #f7f3ee;
  line-height: 1.4;
  margin: 0 0 16px 0;
  padding: 0 10px;
}

.palette-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.palette-img {
  max-width: 200px;
  width: 100%;
  height: auto;
  object-fit: contain;
}

/* ===== MODAL FINO ESTILO TARJETA CONTENEDOR ===== */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  box-sizing: border-box;
  cursor: pointer;
}

.modal-container-wrapper {
  position: relative;
  max-width: 380px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.bg-contenedor-modal {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 20px;
  font-weight: bold;
  color: #1a1a1a;
  cursor: pointer;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.close-btn:active,
.close-btn:hover {
  background-color: #ffffff;
  transform: scale(1.1);
}

.modal-content-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -48%);
  width: 68%;
  text-align: center;
  z-index: 2;
}

.modal-flower-icon {
  width: 132px;
  height: auto;
  margin: 0 auto 6px auto;
  display: block;
  object-fit: contain;
  transform: scaleX(-1);
  will-change: transform, opacity;
  animation: editorialFlowerEnter 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes editorialFlowerEnter {
  0% {
    opacity: 0;
    transform: scaleX(-1) translateY(-8px) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scaleX(-1) translateY(0) scale(1);
  }
}

.modal-message {
  font-family: 'Cormorant Garamond', serif;
  font-style: italic;
  font-size: 13.5px;
  color: #222;
  line-height: 1.25;
  margin: 0 0 12px 0;
}

.gift-option {
  margin-bottom: 10px;
}

.option-title {
  font-family: 'Playfair Display', serif;
  font-size: 13px;
  margin: 0 0 2px 0;
  color: #1a1a1a;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.option-code {
  font-size: 11px;
  color: #444;
  margin: 0 0 6px 0;
}

.btn-modal-link {
  display: inline-block;
  padding: 5px 12px;
  background-color: #000;
  color: #fff;
  border-radius: 14px;
  font-size: 9px;
  text-decoration: none;
  letter-spacing: 0.5px;
}

.envelope-option {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.envelope-icon {
  width: 118px;
  height: auto;
  margin-bottom: 2px;
  object-fit: contain;
}

.envelope-desc {
  font-size: 9.5px;
  color: #555;
  margin: 0;
  line-height: 1.2;
}

/* Transición Modal */
.fade-modal-enter-active,
.fade-modal-leave-active {
  transition: opacity 0.3s ease;
}

.fade-modal-enter-from,
.fade-modal-leave-to {
  opacity: 0;
}

@media (max-width: 360px) {
  .modal-container-wrapper {
    max-width: 330px;
  }
  .modal-message {
    font-size: 11px;
  }
  .option-title {
    font-size: 11px;
  }
}
</style>